import { createFileRoute } from "@tanstack/react-router";
import { PitchDeck } from "@/components/marketing/site/pitch/pitch-deck";
import { GEMSTONE_DECK } from "@/components/marketing/site/pitch/gemstone-content";

/** The deck prepared for one prospect. Kept out of the index and the sitemap on purpose: it names a
 * prospect and carries their offer, so it is reached only by the link the presenter holds. */
function GemstonePitch() {
  return <PitchDeck content={GEMSTONE_DECK} />;
}

export const Route = createFileRoute("/v2/pitch/gemstone")({
  component: GemstonePitch,
  head: () => ({
    meta: [
      { title: "Gemstone Senior Living | PPL" },
      { name: "robots", content: "noindex,nofollow" },
      { name: "description", content: "A walkthrough of PPL prepared for Gemstone Senior Living." },
    ],
  }),
});
